module.exports = __webpack_public_path__ + "assets/delete.bf576da4.svg";